export const IS_APPOINTMENT_SURVEY_APPEARED_STORAGE_KEY = 'isAppointmentSurveyAppeared';
